import { RegisterTextElement } from "./RegisterTextElement";
import { FieldElement } from "./Elements/Text/FieldElement";
import { StyleElement } from "./Elements/Text/StyleElement";
import { TextElement } from "./Elements/Text/TextElement";
import { LineBreakElement } from "./Elements/Text/LineBreakElement";
import { BlockQuoteElement } from "./Elements/Text/BlockQuoteElement";
import { HorizontalLineElement } from "./Elements/Text/HorizontalLineElement";
import { CodeElement } from "./Elements/Text/CodeElement";
import { SubstitutionTextElement } from "./Elements/SubstitutionTextElement";
import { ConditionalElement } from "./Elements/ConditionalElement";
import { IterationTextMergeElement } from "./Elements/IterationTextMergeElement";
import { JSONXMLStringElement } from "./Elements/JSONXML/JSONXMLStringElement";
import { JSONXMLNumberElement } from "./Elements/JSONXML/JSONXMLNumberElement";
import { JSONXMLBooleanElement } from "./Elements/JSONXML/JSONXMLBooleanElement";
import { JSONXMLDateElement } from "./Elements/JSONXML/JSONXMLDateElement";
import { JSONXMLObjectElement } from "./Elements/JSONXML/JSONXMLObjectElement";
import { JSONXMLBuildObjectElement } from "./Elements/JSONXML/JSONXMLBuildObjectElement";
import { XMLAttributeElement } from "./Elements/JSONXML/XMLAttributeElement";

export class RegisterTextElements {
    static registrationRun: boolean = false;

    static doRegistration() {
        if (this.registrationRun) return;

        this.registrationRun = true;

        RegisterTextElement(new FieldElement());
        RegisterTextElement(new TextElement());
        RegisterTextElement(new LineBreakElement());
        RegisterTextElement(new StyleElement());
        RegisterTextElement(new BlockQuoteElement());
        RegisterTextElement(new CodeElement());
        RegisterTextElement(new HorizontalLineElement());
        RegisterTextElement(new LineBreakElement());
        RegisterTextElement(new SubstitutionTextElement());
        RegisterTextElement(new ConditionalElement());
        RegisterTextElement(new IterationTextMergeElement());

        RegisterTextElement(new JSONXMLStringElement());
        RegisterTextElement(new JSONXMLNumberElement());
        RegisterTextElement(new JSONXMLBooleanElement());
        RegisterTextElement(new JSONXMLDateElement());
        RegisterTextElement(new JSONXMLObjectElement());
        RegisterTextElement(new JSONXMLBuildObjectElement());

        RegisterTextElement(new XMLAttributeElement());
    }
}
